/** Enum `Plateforme` du back : application appelante, exigée par le DTO V2 de modification d'une course. */
export enum Plateforme {
  Web = 0,
  Mobile = 1,
}
